module.exports = __webpack_public_path__ + "img/37c360d070e8daee7c555d858a3d2178.png";